import createAndSaveQuoteMetadata from 'core/controllerPlans/create-and-save-quote-metadata'
import config from 'sites/enroll.pivothealth.com/start-application/config'
import controller from 'core/controllerPlans'
import once from 'utils/functional/once'
import updateDOM from './updateDOM'
import initDOM from './initDOM'
import finish from './finish'
import { START_APPLICATION } from 'sites/routes'
import './styles.scss'

const registry = [
  once(initDOM),
  updateDOM,
  once(finish),
  once(createAndSaveQuoteMetadata(START_APPLICATION))
]

controller(config, registry)
